import { Page } from "@/models/page-models/Page";

export const FtDashboard: Page = {
  "path": "ft-dashboard",
  "name": "FT Dashboard",
  "props": {
    "data": {
      "title": "Dashboard",
      "printable": "FALSE",
      "url": "ft-dashboard",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "Pending FT",
              "bracketValueFormula": "{{fetchedData.ordersPendingFT.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending FT",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersPendingFT.data}}",
                      "items": "fetchedData.ordersPendingFT.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyPendingFtSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersPendingFtForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyPendingFtSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersPendingFt"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Update Delivery Date",
                          "priority": "main",
                          "showIf": "fn(MATCH_ROLE,Production | Planner)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copyDeliveryDate"
                            },
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openDeliveryDatePopup"
                            }
                          ]
                        },
                        {
                          "label": "Create Factory Ticket",
                          "priority": "menu",
                          "showIf": "fn(MATCH_ROLE,Production | Planner)",
                          "disableIf": "fn(LOGICAL,fn(LOGICAL,fn(LENGTH,{{__item}}),>,1),||,fn(LOGICAL,{{__item.0.factoryTicket}},!==,0))",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "redirectToCreateFactoryTicket"
                            }
                          ]
                        },
                        {
                          "label": "Mark As Hold",
                          "priority": "menu",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markProductionHoldStatus"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingFt",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersPendingFtForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersPendingFT.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersPendingFt"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersPendingFT.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "On Hold",
              "bracketValueFormula": "{{fetchedData.ordersOnHold.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders On Hold",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersOnHold.data}}",
                      "items": "fetchedData.ordersOnHold.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrdersOnHoldSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersOnHoldForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrdersOnHoldSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersOnHold"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Mark As Under Production",
                          "priority": "menu",
                          "showIf": "fn(MATCH_ROLE,Production | Manager)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),<,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "markAsUnderProduction"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingFt",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersOnHold",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 2,
                              "name": "getOrdersPendingCompletion",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersOnHoldForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersOnHold.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersOnHold"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersOnHold.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Pending Production Reports",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.ordersPendingProductionReports}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Pending Production Reports",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersPendingProductionReports}}",
                      "items": "fetchedData.ordersPendingProductionReports",
                      "headers": [
                        {
                          "value": "order._id",
                          "text": "Order #",
                          "type": "custom-url",
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openPendingOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "order.factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.order.factoryTicket}}"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "noOfProductionReports",
                          "text": "No of Production Reports"
                        },
                        {
                          "value": "productionReports.0.updatedAt",
                          "text": "Production Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.productionReports.0.updatedAt}})"
                        },
                        {
                          "value": "order.deliveryDate",
                          "text": "Delivery Date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.order.deliveryDate}})"
                        },
                        {
                          "value": "order.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.order.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "order.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.order.product}})"
                        },
                        {
                          "value": "order.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "order.unit.unit2",
                          "text": "Unit"
                        },
                        {
                          "value": "order.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.order.quantity}},{{__item.order.FOC}}))"
                        },
                        {
                          "value": "order.status",
                          "text": "Order Status"
                        }
                      ],
                      "tableType": "static",
                      "height": "73vh"
                    }
                  ]
                }
              ],
              "showIf": "fn(MATCH_ROLE,Production | Manager)"
            },
            {
              "tabName": "Pending Completion",
              "bracketValueFormula": "{{fetchedData.ordersPendingCompletion.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Orders Pending Dispatch",
                      "disabled": "FALSE",
                      "showIf": "{{fetchedData.ordersPendingCompletion.data}}",
                      "items": "fetchedData.ordersPendingCompletion.data.docs",
                      "headers": [
                        {
                          "value": "_id",
                          "text": "Order #",
                          "type": "custom-url",
                          "width": 80,
                          "customUrlFns": [
                            {
                              "executionOrder": 1,
                              "name": "openOrderInNewTab"
                            }
                          ]
                        },
                        {
                          "value": "factoryTicket",
                          "text": "FT #",
                          "type": "url",
                          "url": "/factory-ticket/{{__item.factoryTicket}}"
                        },
                        {
                          "value": "__item.customerPO",
                          "text": "Customer PO#"
                        },
                        {
                          "value": "productionStatusString",
                          "text": "Production Status",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,currentFTProgress,{{__item.currentFTProgress}})"
                        },
                        {
                          "value": "__item.deliveryDate",
                          "text": "Delivery Date",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.deliveryDate}})"
                        },
                        {
                          "value": "__item.customer.name",
                          "text": "Customer",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})",
                          "variableType": "item"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.product.repeatType",
                          "text": "Product Type",
                          "type": "productRepeatType"
                        },
                        {
                          "value": "__item.unit.unit2",
                          "text": "Unit",
                          "width": 70
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Order Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUM,{{__item.quantity}},{{__item.FOC}}))"
                        },
                        {
                          "value": "balance.totalQuantityProduced",
                          "text": "Produced Qty",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,{{__item.balance.totalQuantityProduced}})"
                        },
                        {
                          "value": "balanceQuantity",
                          "text": "Balance Quantity",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numberAbbreviation,fn(SUBTRACT,fn(SUM,{{__item.quantity}},{{__item.FOC}}),{{__item.balance.totalQuantityProduced}}))"
                        },
                        {
                          "value": "__item.status",
                          "text": "Order Status"
                        },
                        {
                          "value": "__item.callOff.target",
                          "text": "Target",
                          "formula": "fn(HELPER_FN,orderTarget,{{__item.callOff.target}})"
                        }
                      ],
                      "tableType": "static",
                      "showActions": true,
                      "selectableUniqueId": "_id",
                      "enableSearch": true,
                      "searchFunctions": [
                        {
                          "executionOrder": 1,
                          "pageFunction": {
                            "name": "copyOrdersPendingCompletionSearchString",
                            "type": "fnCopyData",
                            "arg1Key": "sourceKey",
                            "arg1Value": "__item",
                            "arg2Key": "sourceFn",
                            "arg2Value": "getSearchString",
                            "arg3Key": "destinationKey",
                            "arg3Value": "fetchedData.ordersPendingCompletionForm",
                            "arg4Key": "destinationKeyType",
                            "arg4Value": "Object",
                            "arg5Key": "append",
                            "arg5Value": "TRUE"
                          },
                          "name": "copyOrdersPendingCompletionSearchString"
                        },
                        {
                          "executionOrder": 2,
                          "name": "getOrdersPendingCompletion"
                        }
                      ],
                      "groupActions": [
                        {
                          "label": "Update Delivery Date",
                          "priority": "main",
                          "showIf": "fn(MATCH_ROLE,Production | Planner)",
                          "disableIf": "fn(LOGICAL,fn(LENGTH,{{__item}}),>,1)",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "name": "copyDeliveryDate"
                            },
                            {
                              "executionOrder": 1,
                              "name": "copySelectedOrder"
                            },
                            {
                              "executionOrder": 2,
                              "name": "openDeliveryDatePopup"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "height": "69vh",
                      "pagination": {
                        "pageVariable": "fetchedData.ordersPendingCompletionForm.page",
                        "serverItemsLengthVariable": "fetchedData.ordersPendingCompletion.data.totalDocs",
                        "pageChangeFns": [
                          {
                            "executionOrder": 2,
                            "name": "getOrdersPendingCompletion"
                          }
                        ],
                        "itemsPerPageVariable": "fetchedData.ordersPendingCompletion.data.limit"
                      }
                    }
                  ]
                }
              ]
            },
            {
              "tabName": "Sample",
              "bracketValueFormula": "{{fetchedData.productionSamples.data.totalDocs}}",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "Production Sample",
                      "disabled": "FALSE",
                      "items": "fetchedData.productionSamples.data.docs",
                      "headers": [
                        {
                          "value": "__item._id",
                          "text": "Sample",
                          "type": "url",
                          "url": "/sample/{{__item._id}}"
                        },
                        {
                          "value": "__item.customer.alias",
                          "text": "Customer Name",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,customerAlias,{{__item.customer}})"
                        },
                        {
                          "value": "__item.product",
                          "text": "Product",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.product}})"
                        },
                        {
                          "value": "__item.createdBy.displayName",
                          "text": "Salesman"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity",
                          "type": "formula",
                          "formula": "fn(CONCAT,{{__item.quantity}}, ,{{__item.unit}},(s))"
                        },
                        {
                          "value": "__item.deliverTo",
                          "text": "Deliver To"
                        },
                        {
                          "value": "updatedAt",
                          "text": "Last Updated",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.updatedAt}})"
                        },
                        {
                          "value": "__item.status",
                          "text": "Status"
                        }
                      ],
                      "tableType": "static",
                      "confirmDelete": false,
                      "canDelete": false,
                      "showActions": false,
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Mark as Produced",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "markAsOpen",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/sample/{{__item._id}}/mark-produced",
                                "arg2Key": "postData",
                                "arg2Value": "\"{}\"",
                                "arg3Key": "requestMethod",
                                "arg3Value": "PATCH",
                                "arg4Key": "fnsAfterSubmit",
                                "arg4Value": "getProductionSamples"
                              },
                              "name": "markAsOpen"
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar": true,
                      "pagination": {
                        "pageVariable": "fetchedData.productionSampleSearch.page",
                        "serverItemsLengthVariable": "fetchedData.productionSamples.data.totalDocs",
                        "itemsPerPageVariable": "fetchedData.productionSampleSearch.limit",
                        "pageChangeFns": [
                          {
                            "executionOrder": 1,
                            "name": "getProductionSamples"
                          }
                        ]
                      },
                      "height": "70vh"
                    }
                  ]
                }
              ],
              "showIf": "fn(MATCH_ROLE,Production | Manager)"
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Change Delivery Date",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "label",
                  "variable": "fetchedData.selectedOrder",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,orderDescription,{{fetchedData.selectedOrder}})"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.deliveryDate",
                  "label": "Delivery Date",
                  "disabled": "FALSE"
                }
              ]
            }
          ],
          "popupActions": [
            {
              "label": "Submit",
              "onClick": [
                {
                  "executionOrder": 1,
                  "name": "submitDeliveryDate"
                },
                {
                  "executionOrder": 2,
                  "name": "closeDeliveryDatePopup"
                }
              ]
            }
          ],
          "width": "500"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "copyOrdersPendingFtForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersPendingFt"
      },
      {
        "executionOrder": 1,
        "name": "copyOrdersOnHoldForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersOnHold"
      },
      {
        "executionOrder": 1,
        "name": "copyOrdersPendingCompletionForm"
      },
      {
        "executionOrder": 2,
        "name": "getOrdersPendingCompletion"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getUnapprovedProductionReports",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/production/reports/unapproved",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.productionReports",
          "arg3Key": "sourceTransformationFn",
          "arg3Value": "getGroupedProductionReports",
          "arg4Key": "fnsAfterSubmit",
          "arg4Value": "copyFilteredOrdersPendingProductionReports"
        },
        "name": "getUnapprovedProductionReports",
        "executeIf": "fn(MATCH_ROLE,Production | Manager)"
      },
      {
        "executionOrder": 1,
        "name": "copyDefaultProductionSampleSearchObject",
        "pageFunction": {
          "name": "copyDefaultProductionSampleSearchObject",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultProductionSampleSearchObject",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.productionSampleSearch",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "executeIf": "fn(MATCH_ROLE,Production | Manager)"
      },
      {
        "executionOrder": 2,
        "name": "getProductionSamples",
        "executeIf": "fn(MATCH_ROLE,Production | Manager)"
      }
    ],
    "functions": [
      {
        "name": "getOrdersPendingFt",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get?orderStatus=Unplanned&orderStatus=Pending+FT&page={{fetchedData.ordersPendingFtForm.page}}&limit={{fetchedData.ordersPendingFtForm.limit}}&search={{fetchedData.ordersPendingFtForm.search}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersPendingFT",
        "arg3Key": "postData",
        "arg3Value": "{}"
      },
      {
        "name": "getOrdersOnHold",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersOnHold",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersOnHoldForm"
      },
      {
        "name": "getOrdersPendingCompletion",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/get",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.ordersPendingCompletion",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.ordersPendingCompletionForm"
      },
      {
        "name": "copyDeliveryDate",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getDeliveryDate",
        "arg2Key": "destinationKey",
        "arg2Value": "formData",
        "arg3Key": "destinationKeyType",
        "arg3Value": "Object",
        "arg4Key": "append",
        "arg4Value": "TRUE",
        "arg5Key": "sourceKey",
        "arg5Value": "__item"
      },
      {
        "name": "copySelectedOrder",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg1Value": "__item",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.selectedOrder"
      },
      {
        "name": "getDeliveryDate",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "deliveryDate": "fn(HELPER_FN,dateFormat,{{__selectedObject.deliveryDate}},date-picker)"
        },
        "useFormula": true
      },
      {
        "name": "openDeliveryDatePopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Change Delivery Date"
      },
      {
        "name": "closeDeliveryDatePopup",
        "type": "fnClosePopup",
        "arg1Key": "popupName",
        "arg1Value": "Change Delivery Date"
      },
      {
        "name": "submitDeliveryDate",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/order/update/{{fetchedData.selectedOrder._id}}/delivery-date",
        "arg2Key": "postData",
        "arg2Value": "formData",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "redirectToCreateFactoryTicket",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/factory-ticket",
        "arg2Key": "queryParams",
        "arg2Value": "{\"order\":\"{{__selectedObject._id}}\"}"
      },
      {
        "name": "markProductionHoldStatus",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-production-hold",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "markAsUnderProduction",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/order/{{__item._id}}/mark-under-production",
        "arg2Key": "postData",
        "arg2Value": "\"{}\""
      },
      {
        "name": "getUnapprovedProductionReports",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/production/reports/unapproved",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.productionReports",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "getGroupedProductionReports",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "copyFilteredOrdersPendingProductionReports"
      },
      {
        "name": "getGroupedProductionReports",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "orders": "fn(HELPER_FN,groupProductionReportsByOrder,{{__selectedObject.data}})"
        },
        "useFormula": true
      },
      {
        "name": "openOrderInNewTab",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/order/{{__item._id}}",
        "arg2Key": "openNewTab",
        "arg2Value": "TRUE"
      },
      {
        "name": "openPendingOrderInNewTab",
        "type": "fnRedirect",
        "arg1Key": "redirectUrl",
        "arg1Value": "/order/{{__item.order._id}}",
        "arg2Key": "openNewTab",
        "arg2Value": "TRUE"
      },
      {
        "name": "copyFilteredOrdersPendingProductionReports",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getFilteredOrdersPendingProductionReports",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersPendingProductionReports"
      },
      {
        "name": "getFilteredOrdersPendingProductionReports",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.productionReports.orders",
        "arg2Key": "searchKey",
        "arg2Value": "order.status",
        "arg3Key": "formulaCondition",
        "arg3Value": "fn(LOGICAL,fn(LOGICAL,fn(CONCAT,',{{__item.order.status}},'),==,'Under Production'),||,fn(LOGICAL,fn(CONCAT,',{{__item.order.status}},'),==,'Invoice Issued'))"
      },
      {
        "name": "copyOrdersPendingFtForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersPendingFtForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersPendingFtForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersPendingFtForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "search": ""
        },
        "staticObject": true
      },
      {
        "name": "copyOrdersOnHoldForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersOnHoldForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersOnHoldForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersOnHoldForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Hold"
        },
        "staticObject": true
      },
      {
        "name": "copyOrdersPendingCompletionForm",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "getOrdersPendingCompletionForm",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.ordersPendingCompletionForm",
        "arg4Key": "destinationKeyType",
        "arg4Value": "Object"
      },
      { 
        "name": "getOrdersPendingCompletionForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "orderStatus": "Pending Completion"
        },
        "staticObject": true
      },
      {
        "name": "getSearchString",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": "1",
          "search": "{{__selectedObject}}"
        },
        "useFormula": true
      },
      {
        "name": "filterFgRequests",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.transferRequests.data",
        "arg2Key": "searchKey",
        "arg2Value": "rawMaterial.status",
        "arg3Key": "searchValue",
        "arg3Value": "FG"
      },
      {
        "name": "getDefaultProductionSampleSearchObject",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "page": 1,
          "limit": 50,
          "q": {
            "status": [
              "Production"
            ]
          }
        },
        "staticObject": true
      },
      {
        "name": "getProductionSamples",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/sample/search",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.productionSamples",
        "arg3Key": "postData",
        "arg3Value": "fetchedData.productionSampleSearch"
      }
    ]
  },
  "forRole": "PRODUCTION_MANAGER,PRODUCTION_PLANNER",
  "visible": true,
  "routerPriority": 100
}